import appModule from '@/app-module';

export default {
  beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.notEmptyPermissions) {
      next();
      return;
    }

    const store = appModule.storeAsync();

    store.dispatch('auth/waitUntilInit').then(() => {
      if (
        store.getters['auth/authenticated'] &&
        store.getters['auth/hasRole']()
      ) {
        next('/');
      } else {
        next();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/auth/guards/not-empty-permissions-guard-mixin.js